import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, inject, Loader, asStringOrEmpty, bind } from 'Mri.Web.Common';
import { parse } from 'qs';
import * as React from 'react';
import { BsCheckCircle } from '@react-icons/all-files/bs/BsCheckCircle';
import { BsXCircle } from '@react-icons/all-files/bs/BsXCircle';
import { RouteComponentProps } from 'react-router';
import { UnsubscribeStore } from './UnsubscribeStore';

export interface IUnsubscribeProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class UnsubscribeView extends React.Component<IUnsubscribeProps> {
    public render() {
        return (
            <div className="container h-100">
                <div className="row h-100">
                    <div className="col-12 h-100 pt-5 text-center">
                        <div className="card w-100 p-5 text-center">
                            {!this.unsubscribed && (
                                <div>
                                    <div className="mb-5">
                                        <span>Are you sure you would like to unsubscribe from all future emails?</span>
                                    </div>
                                    <button className="btn btn-primary mx-auto" onClick={this.unsubscribeAsync}>
                                        Unsubscribe {this.email}
                                    </button>
                                </div>
                            )}
                            <Loader loading={this.loading} showSpinner />
                            {!this.loading && !this.error && this.unsubscribed && (
                                <>
                                    <BsCheckCircle className="text-teal f-84 pb-4" />
                                    <h2>You Have Been Unsubscribed</h2>
                                </>
                            )}
                            {!this.loading && this.error && (
                                <>
                                    <BsXCircle className="text-danger f-84 pb-4" />
                                    <h2>Unsubscribe Request Failed</h2>
                                    {this.error.message}
                                </>
                            )}
                        </div>

                        <div className="mt-3">
                            <small className="header-color">SmartVu® Advanced Monitoring Portal</small>
                            <br />
                            <a href="https://portal.mri-inc.net" className="btn btn-link">
                                Click Here to return to Portal
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    @action
    @bind
    private async unsubscribeAsync() {
        this.loading = true;

        try {
            if (!this.userId || !this.alertActionGuid) throw new Error('Invalid UserID or Action');

            await this.unsubscribeStore.unsubscribeDisplayAlert(this.userId, this.alertActionGuid);
        } catch (e: any) {
            this.error = e;
        } finally {
            this.unsubscribed = true;
            this.loading = false;
        }
    }

    @computed
    private get userId() {
        const query = parse(this.props.location.search.slice(1));
        return asStringOrEmpty(query.userId);
    }

    @computed
    private get email() {
        const query = parse(this.props.location.search.slice(1));
        return asStringOrEmpty(query.email);
    }

    @computed
    private get alertActionGuid() {
        const query = parse(this.props.location.search.slice(1));
        return asStringOrEmpty(query.alertActionGuid);
    }

    @observable
    private loading: boolean = false;
    @observable
    private unsubscribed: boolean = false;
    @observable
    private error?: Error;
    @inject
    private unsubscribeStore!: UnsubscribeStore;
}
